import React, { PureComponent, ReactNode } from 'react';
import styled from 'styled-components';
import Button from '../ui_components/button/button';
import { Modal, ModalActions, ModalContent, ModalHeader } from '../ui_components/modal';

const PrintModalContainer = styled(Modal)`
  width: 480px;
  height: 400px;
  bottom: 0;
`;

const ConfirmButton = styled(Button)`
  border-radius: 5px;
  box-shadow: none;
  line-height: 0.6rem;
  &:hover,
  &.active {
    background: #44aecc;
  }
  &:focus {
    border: 1px solid #3377ff;
  }
`;

const CancelButton = styled(Button)`
  background-color: #f6f6f6;
  border-radius: 0.5em;
  border: 1px solid #cdcdcd;
  color: #222222;

  &:hover {
    background-color: #eeeeee;
  }
`;

const PrintModalContent = styled(ModalContent)`
  display: flex;
  flex-flow: row wrap;
  flex-direction: column;
  justify-content: space-between;
  padding: 25px;
`;

const PrintModalTitle = styled.span`
  font-size: 18px;
  font-weight: 500;
`;

interface PrintModalOwnProps {
  isModalOpen: boolean;
  onClose(): void;
  handlePrint?(id?: any): Promise<void>;
  selectedItemsNumber: number;
  preparedItemsNumber: number;
}

export interface PrintModalProps extends PrintModalOwnProps {
  accountId: number;
}

export default class PrintModal extends PureComponent<PrintModalProps> {
  render(): ReactNode {
    const { preparedItemsNumber, selectedItemsNumber } = this.props;
    return (
      <PrintModalContainer
        style={{ height: '280px' }}
        uiActive={this.props.isModalOpen}
        uiOnRequestClose={() => {}}
        uiDefaultSizes={false}
      >
        <ModalHeader style={{ display: 'flex', alignItems: 'center' }}>
          <PrintModalTitle>Some work orders are not ready yet</PrintModalTitle>
        </ModalHeader>
        <PrintModalContent>
          <div>
            {`You selected ${selectedItemsNumber} items. ${preparedItemsNumber} work order${
              preparedItemsNumber !== 1 ? 's' : ''
            } ${preparedItemsNumber !== 1 ? 'are' : 'is'} ready${
              preparedItemsNumber > 0 ? ' and will be sent to print' : ''
            }.
                Items without work orders will not be included.`}
          </div>
        </PrintModalContent>
        <ModalActions
          style={{
            borderTop: 'none',
            display: 'flex',
            justifyContent: preparedItemsNumber > 0 ? 'space-between' : 'flex-end',
          }}
        >
          <CancelButton onClick={this.props.onClose} id="cancel" uiColor="secondary">
            Cancel
          </CancelButton>
          {preparedItemsNumber > 0 && (
            <ConfirmButton
              onClick={() => {
                this.props.onClose();
                if (this.props.handlePrint) this.props.handlePrint();
              }}
              id="confirm"
              uiColor="#3B97B1"
            >
              Continue to Print
            </ConfirmButton>
          )}
        </ModalActions>
      </PrintModalContainer>
    );
  }
}
